import { faArrowLeft, faXmark } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { useDrawerContext } from 'components/UI/V3/Drawer/DrawerContext';
import styles from 'components/UI/V3/Drawer/Header/DrawerHeader.module.scss';
import React from 'react';

interface DrawerHeaderProps {
    title: string;
    actions?: React.ReactNode;
    sticky?: boolean;
    className?: string;
    onBack?: () => void;
    alwaysShowClose?: boolean;
}

export const DrawerHeader: React.FC<DrawerHeaderProps> = ({
    title,
    actions,
    className,
    sticky,
    onBack,
    alwaysShowClose
}) => {
    const { close } = useDrawerContext();

    return (
        <div className={clsx(styles.root, className, { [styles.sticky]: sticky })}>
            <p className={styles.title}>
                {onBack && (
                    <button
                        type="button"
                        onClick={onBack}
                        className={styles.backButton}
                    >
                        <FontAwesomeIcon icon={faArrowLeft} />
                    </button>
                )}

                {title}
            </p>

            <div className={styles.actions}>
                {actions}

                <button
                    type="button"
                    onClick={close}
                    className={clsx(styles.closeButton, { [styles.alwaysVisible]: alwaysShowClose })}
                    aria-label="Close"
                >
                    <FontAwesomeIcon icon={faXmark} />
                </button>
            </div>
        </div>
    );
};
